import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Ana kabuğun içerik alanı (main.component.html). Bunun dışındaki başlıklar (popup'lar, e-Belediye/mobil kabuklar) sayılmaz. */
const KOK_SECICI = '[data-tam-ekran-kok]';
/** Ekranlar dk-route-tab-lazy'de sekme olarak açılır; her sekmenin içerik kutusu bu işareti taşır (ekran içindeki iç sekmeler değil). */
const SEKME_SECICI = '[data-tam-ekran-sekme]';
const GOVDE_SINIFI = 'dk-tam-ekran';

/**
 * Açık sekmeyi tam ekran yapar: üst çubuk, sol menü ve sekme şeridi gizlenir, sayfa tarayıcı tam ekranına geçer;
 * ekranda yalnız o sekmenin içeriği kalır.
 * Sekmenin kendi kutusu tam ekrana alınmaz (Analiz Merkezi'ndeki gibi) — DevExtreme açılır pencereleri
 * (lookup listesi, popup, uyarı) body'ye eklendiği için o kutunun dışında kalıp görünmezdi.
 *
 * Düğme her sekmenin ilk başlığında (dk-list-header / dk-form-header) çıkar; iç grid başlıklarında ve popup'larda çıkmaz.
 */
@Injectable({ providedIn: 'root' })
export class TamEkranService {
  private readonly aktifKaynak = new BehaviorSubject<boolean>(false);
  readonly aktif$ = this.aktifKaynak.asObservable();

  private readonly sahiplerKaynak = new BehaviorSubject<ReadonlySet<HTMLElement>>(new Set());
  /** Tam ekran düğmesini gösterecek başlık elemanları (sekme başına bir tane). */
  readonly sahipler$ = this.sahiplerKaynak.asObservable();

  private readonly basliklar = new Set<HTMLElement>();
  private hesapBekliyor = false;

  constructor(private zone: NgZone) {
    document.addEventListener('fullscreenchange', () => {
      // Esc ya da tarayıcı tam ekranından çıkış: üst çubuk, menü ve sekmeler geri gelsin
      if (!document.fullscreenElement && this.aktifKaynak.value) this.zone.run(() => this.ayarla(false));
    });
  }

  get aktif(): boolean {
    return this.aktifKaynak.value;
  }

  /** Açık sekmede düğmeli başlık görünüyor mu? Görünmüyorsa kabuk yüzen "çık" düğmesini gösterir. */
  get gorunurSahipVar(): boolean {
    // Arkadaki sekmeler display:none değil, visibility:hidden (dx-multiview-item-hidden) ile saklanıyor
    for (const el of this.sahiplerKaynak.value) if (el.offsetParent !== null && !el.closest('.dx-multiview-item-hidden')) return true;
    return false;
  }

  kaydol(el: HTMLElement) {
    this.basliklar.add(el);
    this.sahipleriHesapla();
  }

  ayril(el: HTMLElement) {
    this.basliklar.delete(el);
    this.sahipleriHesapla();
  }

  degistir() {
    this.ayarla(!this.aktif);
  }

  private ayarla(acik: boolean) {
    document.body.classList.toggle(GOVDE_SINIFI, acik);
    this.aktifKaynak.next(acik);
    if (acik) {
      if (!document.fullscreenElement) document.documentElement.requestFullscreen?.().catch(() => undefined);
    } else if (document.fullscreenElement) {
      document.exitFullscreen?.().catch(() => undefined);
    }
    // Yükseklik hesaplayan grid'ler yeni alana yerleşsin
    setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
  }

  /** Her sekmede belge sırasındaki ilk başlık sahip olur. Başlıklar *ngIf ile geç geldiği için her değişimde yeniden bakılır. */
  private sahipleriHesapla() {
    if (this.hesapBekliyor) return;
    this.hesapBekliyor = true;
    setTimeout(() => {
      this.hesapBekliyor = false;
      const ilkler = new Map<Element, HTMLElement>();
      this.basliklar.forEach(el => {
        const kok = el.isConnected ? el.closest(KOK_SECICI) : null;
        if (!kok) return;
        const grup = el.closest(SEKME_SECICI) ?? kok;
        const ilk = ilkler.get(grup);
        if (!ilk || ilk.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING) ilkler.set(grup, el);
      });
      const yeni = new Set(ilkler.values());
      const eski = this.sahiplerKaynak.value;
      if (yeni.size !== eski.size || [...yeni].some(el => !eski.has(el))) this.sahiplerKaynak.next(yeni);
    });
  }
}
